module.exports = __webpack_public_path__ + "img/202307_08.912d0189.jpg";